<!--
@Author: OuyangQiangqiang
@Date: 2018-06-09
@Description: 这是一个收藏按钮，悬浮于页面的右侧 bd-favorite-button

用例：
<bd-favorite-button @click="openFavoriteDialog"></bd-favorite-button>

-->
<template>
  <div class="cndns-right" v-on:click="$emit('click')">
    <div class="cndns-right-meau meau-car">
      <a href="javascript: void(0)" class="cndns-right-btn">
        <span class="demo-icon">&#xe9d7;</span>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'bd-favorite-button'
}
</script>

<style scoped>
@import '../../assets/css/base/favorite-btn.css';
</style>



// WEBPACK FOOTER //
// src/components/appinfo/bdFavoriteButton.vue